export default __webpack_public_path__ + "static/media/f2.d487452f.svg";